<template>
  <!-- Tablero de control -->
  <v-form :disabled="editedItem.IndModficable != 'S' ? false : true" ref="form" autocomplete="off">
    <v-row>
      <!-- Clase de comunicación  -->
      <v-col cols="12" sm="6" md="6">
        <v-autocomplete
          v-model="editedItem.Clase"
          :update:modelValue="ChangeClase()"
          :items="ArrayTipoNewContact"
          :item-title="
            (ArrayTipoNewContact) =>
              ArrayTipoNewContact.Valor + '-' + ArrayTipoNewContact.Descripcion
          "
          item-value="Valor"
          color="primary"
          label="Clase:"
          dense
          clearable
          :rules="[(v) => !!v || 'Campo obligatorio']"
        >
        </v-autocomplete>
      </v-col>
      <!-- Tipo de persona -->
      <v-col cols="12" sm="6" md="6">
        <v-autocomplete
          v-model="editedItem.Tipo"
          :update:modelValue="ChangeTipo()"
          :items="ArrayClaseNewContact"
          :item-title="
            (ArrayClaseNewContact) =>
              ArrayClaseNewContact.Valor +
              '-' +
              ArrayClaseNewContact.Descripcion
          "
          item-value="Valor"
          color="primary"
          label="Tipo de persona:"
          dense
          clearable
          :rules="[(v) => !!v || 'Campo obligatorio']"
        >
        </v-autocomplete>
      </v-col>
      <!--Nombre Referencia-->
      <v-col v-if="editedItem.Tipo == '1'" cols="12" sm="6" md="6">
        <v-text-field
          v-model="editedItem.Nombre"
          label="Nombre:"
          hint="Digite Información"
          maxlength="200"
          counter="200"
          dense
          clearable
          :rules="[(v) => !!v || 'Campo obligatorio']"
        >
        </v-text-field>
      </v-col>
      <!-- Parentesco -->
      <v-col v-if="editedItem.Tipo == '1'" cols="12" sm="6" md="6">
        <v-autocomplete
          v-model="editedItem.Parenteso"
          :items="ArrayParentescoNewContact"
          :item-title="
            (ArrayParentescoNewContact) =>
              ArrayParentescoNewContact.Valor +
              '-' +
              ArrayParentescoNewContact.Descripcion
          "
          item-value="Valor"
          color="primary"
          label="Parentesco:"
          dense
          clearable
          :rules="[(v) => !!v || 'Campo obligatorio']"
        >
        </v-autocomplete>
      </v-col>
      <!-- País -->
      <v-col
        v-if="editedItem.Clase == '2' || editedItem.Clase == '3'"
        cols="12"
        sm="6"
        md="6"
      >
        <v-autocomplete
          v-model="editedItem.PaisIDPrefijo"
          :items="ArrayPais_ID"
          :item-title="
            (ArrayPais_ID) =>
              ArrayPais_ID.Id +
              '-' +
              ArrayPais_ID.Nombre +
              ' - ' +
              ArrayPais_ID.Prefijo
          "
          item-value="Id"
          color="primary"
          label="Prefijo País:"
          :update:modelValue="ChangePais_ID()"
          dense
          clearable
          :rules="[(v) => !!v || 'Campo obligatorio']"
        >
        </v-autocomplete>
      </v-col>
      <!--Departamento-->
      <v-col v-if="editedItem.Clase == '3'" cols="12" sm="6" md="6">
        <v-autocomplete
          v-model="editedItem.DptoIDPrefijo"
          :items="ArrayDpto_ID"
          :item-title="
            (ArrayDpto_ID) =>
              ArrayDpto_ID.DepartamentoId +
              '-' +
              ArrayDpto_ID.Nombre +
              ' Pref: ' +
              ArrayDpto_ID.Prefijo
          "
          item-value="DepartamentoId"
          color="primary"
          label="Prefijo departamento:"
          dense
          :rules="[(v) => !!v || 'Campo obligatorio']"
          clearable
        >
        </v-autocomplete>
      </v-col>
      <!--Celular o Fijo-->
      <v-col
        v-if="editedItem.Clase == '2' || editedItem.Clase == '3'"
        cols="12"
        sm="6"
        md="6"
      >
        <v-text-field
          v-model="editedItem.Phone"
          :label="editedItem.Clase == '2' ? 'Celular:' : 'Teléfono fijo:'"
          hint="Digite Información"
          dense
          v-on:keypress="isNumber()"
          counter="25"
          maxlength="25"
          clearable
          :rules="[(v) => !!v || 'Campo obligatorio']"
        >
        </v-text-field>
      </v-col>
      <!--Extensión -->
      <v-col
        v-if="editedItem.Clase == '2' || editedItem.Clase == '3'"
        cols="12"
        sm="6"
        md="6"
      >
        <v-text-field
          v-model="editedItem.Ext"
          label="Extensión:"
          v-on:keypress="isNumber()"
          hint="Digite Información"
          dense
          counter="25"
          maxlength="25"
          clearable
        >
        </v-text-field>
      </v-col>
      <!-- Página web o Email-->
      <v-col
        v-if="editedItem.Clase == '1' || editedItem.Clase == '4'"
        cols="12"
        sm="6"
        md="6"
      >
        <v-text-field
          v-model="editedItem.EmailPageWeb"
          :label="
            editedItem.Clase == '1' ? 'Correo electrónico:' : 'Página web:'
          "
          hint="Digite Información"
          dense
          :rules="[(v) => !!v || 'Campo obligatorio']"
          clearable
        >
        </v-text-field>
      </v-col>
      <!-- Observaciones -->
      <v-col cols="12" sm="6" md="12">
        <v-textarea
          v-model="editedItem.Observaciones"
          name="input-7-1"
          filled
          label="Observaciones"
          auto-grow
          clearable
        ></v-textarea>
      </v-col>
    </v-row>
    <!--////////////////////////////////////////////// Auditoria ////////////////////////////////////////////////////////////-->
    <br />
    <v-row>
      <v-col v-if="editedIndex != -1" cols="12" sm="12" md="6">
        <span>Usuario Creación: {{ editedItem.UsuarioCreacion }}</span>
      </v-col>
      <v-col v-if="editedIndex != -1" cols="12" sm="12" md="6">
        <span
          >Usuario Actualización: {{ editedItem.UsuarioActualizacion }}</span
        >
      </v-col>
      <v-col v-if="editedIndex != -1" cols="12" sm="12" md="6">
        <span>Fecha Creación: {{ editedItem.FechaCreacion }}</span>
      </v-col>
      <v-col v-if="editedIndex != -1" cols="12" sm="12" md="6">
        <span>Fecha Actualización: {{ editedItem.FechaActualizacion }}</span>
      </v-col>
    </v-row>
    <div align="right">
      <br />
      <v-btn
        size="x-large"
        v-if="!buttonSave"
        color="green"
        text
        :disabled="editedItem.IndModficable != 'S' ? false : true"
        @click="ValidateCampos"
      >
        Guardar
      </v-btn>
    </div>
  </v-form>
  <!-- Linea de progreso -->
  <div class="d-flex align-center flex-column">
    <v-dialog v-model="progreso" persistent width="auto">
      <v-card color="red-darken-4">
        <v-card-text>
          Espera un momento...
          <v-toolbar align="center" color="red-darken-4">
            <v-img
              class="mx-auto"
              :width="5"
              src="/static/iconos/logo2.png"
            ></v-img>
          </v-toolbar>
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
export default {
  name: "seguros_registro",
  props: {
    editedIndex: {
      type: Number,
      default: 0,
      Description: "Cambia de actualización a creación o visceversa",
    },
    infoedit: {
      type: Object,
      default: [],
      Description: "Información de datos",
    },
    tipodocumento: {
      type: Number,
      default: 0,
      Description: "Información de tipo de documento",
    },
    documento: {
      type: String,
      default: "",
      Description: "Información de documento",
    },
    page: {
      type: Boolean,
      default: false,
      Description: "Saber desde donde se llama la página",
    },
    Exito: {
      type: String,
      default: "",
      Description: "Información de respuesta post o put",
    },
  },
  data() {
    return {
      progreso: false,
      componenteview: 0,
      buttonSave: false,
      editedItem: {
        IdentificadorUnico: null,
        TypeDocument: null,
        Document_ID: null,
        DireccionID: null,
        Tipo: null,
        Clase: null,
        Nombre: null,
        Parenteso: null,
        IndModficable: null,
        PaisIDPrefijo: 169,
        DptoIDPrefijo: null,
        Phone: null,
        Ext: null,
        EmailPageWeb: null,
        Observaciones: null,
        UsuarioCreacion: null,
        FechaCreacion: null,
        UsuarioActualizacion: null,
        FechaActualizacion: null,
      },
      defaultItem: {
        IdentificadorUnico: null,
        TypeDocument: null,
        Document_ID: null,
        DireccionID: null,
        Tipo: null,
        Clase: null,
        Nombre: null,
        Parenteso: null,
        IndModficable: null,
        PaisIDPrefijo: 169,
        DptoIDPrefijo: null,
        Phone: null,
        Ext: null,
        EmailPageWeb: null,
        Observaciones: null,
        UsuarioCreacion: null,
        FechaCreacion: null,
        UsuarioActualizacion: null,
        FechaActualizacion: null,
      },
      ArrayPais_ID: [],
      ArrayDpto_ID: [],
      ArrayTipoNewContact: [],
      ArrayClaseNewContact: [],
      ArrayParentescoNewContact: [],
      wclase: null,
      wtipo: null,
    };
  },
  methods: {
    isNumber: function (evt) {
      evt = evt || window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    ///////////////////////////////////////////////// Métodos de consulta ///////////////////////////////////////////
    // Validación de campos
    async ValidateCampos() {
      var validate = false;
      var correo = false;
      const pattern =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      
      if (
        this.editedItem.TypeDocument == "" ||
        this.editedItem.TypeDocument == null ||
        this.editedItem.Document_ID == "" ||
        this.editedItem.Document_ID == null ||
        this.editedItem.Tipo == "" ||
        this.editedItem.Tipo == null ||
        this.editedItem.Clase == "" ||
        this.editedItem.Clase == null
      ) {
        validate = true;
      } else if (
        (this.editedItem.Clase == "2" || this.editedItem.Clase == "3") &&
        (this.editedItem.Phone == "" ||
          this.editedItem.Phone == null ||
          this.editedItem.PaisIDPrefijo == "" ||
          this.editedItem.PaisIDPrefijo == null)
      ) {
        validate = true;
      } else if (
        this.editedItem.Clase == "3" &&
        (this.editedItem.DptoIDPrefijo == "" ||
          this.editedItem.DptoIDPrefijo == null)
      ) {
        validate = true;
      } else if (
        (this.editedItem.Clase == "1" || this.editedItem.Clase == "4") &&
        (this.editedItem.EmailPageWeb == "" ||
          this.editedItem.EmailPageWeb == null)
      ) {
        validate = true;
      } else if (
        this.editedItem.Clase == "1" &&
        !pattern.test(this.editedItem.EmailPageWeb)
      ) {
        correo = true;
        validate = true;
      }
      // Consultas a Ejecutar
      if (!validate) {
        var userperfil = this.$store.getters.userperfil;
        this.editedItem.UsuarioActualizacion = userperfil.userInfo.Usuario_ID;
        this.editedItem.UsuarioCreacion = userperfil.userInfo.Usuario_ID;
        if (this.editedIndex != -1) {
          this.putRegistro();
        } else {
          this.postRegistro();
        }
      } else if (correo) {
        this.$swal({
          icon: "warning",
          title: "Correo Inválido.",
          html: "El correo registrado es inválido, por favor revisar",
        });
        this.$refs.form.validate();
      } else {
        this.$swal({
          icon: "warning",
          title: "Campos Incompletos.",
          html: " Hay campos que se encuentran incompletos.",
        });
        this.$refs.form.validate();
      }
    },
    // Crear Registro
    async postRegistro() {
      this.progreso = true;
      this.axios
        .post("/Personas/NuevoContacto/CR0/", this.editedItem)
        .then((result) => {
          this.reset();
          var data = false;
          var dataExit = "Exito";
          this.$emit("update:page", data);
          this.$emit("update:Exito", dataExit);
          this.$swal({
            icon: "success",
            title: "¡Éxito!",
            html: " El registro fue guardado correctamente.",
          });
        })
        .catch((error) => {
          const registro = error.response.data;
          const mensajeerror =
            registro.Mensaje || registro.ExceptionMessage || registro;
          switch (error.response.status) {
            case 404:
              this.$swal({
                icon: "warning",
                title: "Consulta inexistente.",
                html: mensajeerror,
              });
              break;
            default:
              this.$swal({
                icon: "error",
                title: "Error al consultar",
                html:
                  " El sistena ha encontrado la siguiente condicion inesperada: <br><small><code>" +
                  mensajeerror +
                  "</code></small>",
              });
              break;
          }
        })
        .finally(() => {
          this.progreso = false;
        });
    },
    // Actualizacion de registro
    async putRegistro() {
      this.progreso = true;
      console.log(this.editedItem);
      this.editedItem.TypeDocument = this.editedItem.TypeDocument.toString();
      this.axios
        .put("/Personas/NuevoContacto/UP0", this.editedItem)
        .then((response) => {
          debugger;
          this.reset();
          var data = false;
          this.$emit("update:page", data);
          this.$emit("update:Exito", response.data);
          this.$swal({
            icon: "success",
            title: "¡Éxito!",
            html: " El registro fue guardado correctamente.",
          });
        })
        .catch((error) => {
          const registro = error.response.data;
          const mensajeerror =
            registro.Mensaje || registro.ExceptionMessage || registro;
          switch (error.response.status) {
            case 404:
              this.$swal({
                icon: "warning",
                title: "Consulta inexistente.",
                html: mensajeerror,
              });
              break;
            default:
              this.$swal({
                icon: "error",
                title: "Error al consultar",
                html:
                  " El sistena ha encontrado la siguiente condicion inesperada: <br><small><code>" +
                  mensajeerror +
                  "</code></small>",
              });
              break;
          }
        })
        .finally(() => {
          this.progreso = false;
        });
    },
    ///////////////////////////////////////////////// Changes ///////////////////////////////////////////
    // Función de gestion cambio
    ChangeClase() {
      if (this.wclase != this.editedItem.Clase) {
        debugger;
        this.wclase = this.editedItem.Clase;
        if (this.editedItem.Clase == "1" || this.editedItem.Clase == "4") {
          this.editedItem.DptoIDPrefijo = null;
          this.editedItem.PaisIDPrefijo = 169;
          this.editedItem.Phone = null;
          this.editedItem.Ext = null;
        } else if (
          this.editedItem.Clase == "2" ||
          this.editedItem.Clase == "3"
        ) {
          this.editedItem.EmailPageWeb = null;
        }
      }
      if (this.editedItem.Clase == null || this.editedItem.Clase == "") {
        this.editedItem.DptoIDPrefijo = null;
        this.editedItem.PaisIDPrefijo = 169;
        this.editedItem.Phone = null;
        this.editedItem.Ext = null;
        this.editedItem.EmailPageWeb = null;
      }
    },
    // Función de gestion Tipo persona
    ChangeTipo() {
      if (this.wtipo != this.editedItem.Tipo) {
        this.wtipo = this.editedItem.Tipo;
        if (this.editedItem.Tipo == "0") {
          this.editedItem.Parenteso = null;
          this.editedItem.Nombre = null;
        }
      }
      if (this.editedItem.Tipo == null || this.editedItem.Tipo == "") {
        this.editedItem.Parenteso = null;
        this.editedItem.Nombre = null;
      }
    },
    // Función de gestion cambio
    ChangePais_ID() {
      if (
        this.editedItem.PaisIDPrefijo != null &&
        this.editedItem.PaisIDPrefijo != ""
      ) {
        this.getDpto_ID();
      } else {
        this.ArrayDpto_ID = [];
        this.editedItem.DptoIDPrefijo = null;
      }
    },
    // Get para obtener array de los departamento existentes
    getDpto_ID() {
      if (this.editedItem.PaisIDPrefijo == "169") {
        this.ArrayDpto_ID = [];
        var ArrayDpto_ID2 = this.$store.getters.MDpto;
        this.ArrayDpto_ID = ArrayDpto_ID2.filter(
          (item) => item.departamentoId != 0
        );
      }
    },
    ///////////////////////////////////////////////// Métodos de acciones ///////////////////////////////////////////
    reset() {
      this.editedItem = Object.assign({}, this.defaultItem);
    },
    // Cargue Combos
    CargueCombos() {
      var ArrayPais = this.$store.getters.MPais;
      this.ArrayPais_ID = ArrayPais.filter((item) => item.Id != 0);
      this.ArrayClaseNewContact = this.$store.getters.MTablaSeleccion.filter(
        (item) => item.Valor != null && item.TablaId == 35
      );
      this.ArrayTipoNewContact = this.$store.getters.MTablaSeleccion.filter(
        (item) => item.Valor != null && item.TablaId == 37
      );
      this.ArrayParentescoNewContact =
        this.$store.getters.MTablaSeleccion.filter(
          (item) => item.Valor != null && item.TablaId == 36
        );
    },
    // Actualizar carga
    ActualizarCargue() {
      if (this.editedIndex != -1) {
        // Actualizar
        this.editedItem = this.infoedit;
      } else {
        this.editedItem.TypeDocument =
          this.tipodocumento != 0 ? this.tipodocumento : null;
        this.editedItem.Document_ID =
          this.documento != null ? this.documento : null;
      }
    },
  },
  mounted() {
    this.CargueCombos();
    this.ActualizarCargue();
  },
};
</script>
